type PageObject = {
  name: string
  description: string
}

type ImpactModulePages = {
  [key: string]: PageObject
}

export const DATA_INTEGRATOR_PAGES: ImpactModulePages = {
  ARCHIVE_FILE: {
    name: 'Arquivos',
    description: 'Gestão dos arquivos da instituição',
  },
  ARCHIVE_DIRECTORY: {
    name: 'Diretórios',
    description: 'Gestão dos diretórios',
  },
  SYSTEM: {
    name: 'Sistemas',
    description: 'Gestão dos sistemas dos dados',
  },
  TERM: {
    name: 'Termos',
    description: 'Gestão dos termos',
  },
  PUBLIC_AGENT_MODULE_PERMISSION: {
    name: 'Permissões de s',
    description: 'Gestão das permissões dos agentes',
  },
  GROUP_MODULE_PERMISSION: {
    name: 'Permissões de grupos',
    description: 'Gestão das permissões dos grupos',
  },
}
